

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Product.Validator.js"

class ProductAPI {


  /*
  POST http://localhost:3000/product/create
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {
      "name" : "Bàn ăn",
      "images":["http://link-anh"],
      "ownerId":"268194731381",
      "ownerType":"contractor"

  }
  */

  create = async (data) => {
    const validator = Validator.VALIDATION_PRODUCT_CREATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/product/create", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
  GET http://api.houselink.com:3000/product/detail/201176822287
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q
  ###

  */


  detail = async (id, data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.get(HOST + "/product/detail/" + id, data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*

  POST http://localhost:3000/product/update
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {
      "id":"201176822287",
      "name" : "Bàn ăn",
      "images":["http://link-anh"],
      "description":"Bàn ăn sang trọng ",
      "colors":["Yellow","Black"]
  }

  */

  update = async (data) => {
    const validator = Validator.VALIDATION_PRODUCT_UPDATE;

    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        console.log(result.error);
        return { validateError: result.error.details[0].message }
      }
    }

    const result = await Request.post(HOST + `/product/update`, data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };



  /*
  POST http://api.houselink.com:3000/product/search
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {

      "orderBy":"updatedAt",
      "orderType":"DESC",
  //    "isPriceHighToLow": true
          "isPriceLowToHigh": true
  }
  */


  search = async (data) => {
    const validator = Validator.VALIDATION_PRODUCT_SEARCH;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/product/search", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*


  POST http://localhost:3000/product/approve
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

  {
      "id":"522911722487",
      "approved" : true
  }

  */


  approve = async (data) => {
    const validator = Validator.VALIDATION_PRODUCT_APPROVE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/product/approve", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*


  POST http://localhost:3000/product/adminList
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

  {
      "name" : "xây dựng",
      "orderBy":"updatedAt",
      "orderType":"DESC",
      "approved":false
  }


  */


  adminList = async (data) => {
    const validator = false; // change this to real variable
    if (validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if (result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/product/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*

  POST http://localhost:3000/product/delete
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI3OTQzMjc1OTUzMTciLCJjcmVhdGVkQXQiOjE1Mjk1ODgxMDY4MDd9.PlLQ8y3PotILHHZlDzq8fk4qL4P4ZqbVj20USNgqQVc
  Content-Type: application/json

  {"id":"4804148671","ownerId":"242007884675"}

  */
  delete = async (data) => {
    const validator = Validator.VALIDATION_PRODUCT_DELETE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/product/delete", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }
}

export default new ProductAPI();



// WEBPACK FOOTER //
// ./src/services/product/Product.API.js